/**
 * Webhooks Module Routes
 * Story 6.3
 */

import { lazy } from "react";
import { ModuleRoutes } from "../types";

// Lazy load components
const WebhookList = lazy(() => import("@/pages/Webhooks/WebhookList"));
const WebhookCreate = lazy(() => import("@/pages/Webhooks/WebhookCreate"));
const WebhookDetails = lazy(() => import("@/pages/Webhooks/WebhookDetails"));
const WebhookEdit = lazy(() => import("@/pages/Webhooks/WebhookEdit"));

export const webhooksRoutes: ModuleRoutes = {
  moduleId: "webhooks",
  basePath: "/webhooks",
  routes: [
    {
      path: "/webhooks",
      element: <WebhookList />,
      permission: { resource: "webhooks", action: "view" },
    },
    {
      path: "/webhooks/new",
      element: <WebhookCreate />,
      permission: { resource: "webhooks", action: "create" },
    },
    {
      path: "/webhooks/:id",
      element: <WebhookDetails />,
      permission: { resource: "webhooks", action: "view" },
    },
    {
      path: "/webhooks/:id/edit",
      element: <WebhookEdit />,
      permission: { resource: "webhooks", action: "update" },
    },
  ],
};
